export const validateAccountNumber = (accountNumber: string): string => {
  return accountNumber.replaceAll(/\s/g, "").trim().length === 11 ? "" : "Ugyldig konto. Må være 11 siffer.";
};
